import { Button } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { useCallback, useMemo } from "react";
import { QuestionOption } from "src/api/types";
import { useAnswer } from "src/context/AnswerProvider";

interface Props {
  option: QuestionOption;
  onSelect: (option: QuestionOption) => void;
  isMultipleChoice?: boolean;
}

const ChoiceOption = ({
  option,
  onSelect,
  isMultipleChoice = false,
}: Props) => {
  const { answers } = useAnswer();

  const handleSelect = useCallback(() => onSelect(option), [onSelect, option]);
  const isSelected = useMemo(
    () => answers.includes(option.value),
    [answers, option.value],
  );

  return (
    <Button
      variant={"outlined"}
      onClick={handleSelect}
      sx={{
        border: `${isSelected ? "2" : "1"}px solid ${
          isSelected ? "#00B6B9" : "#c4c4c4"
        }`,
        display: "flex",
        justifyContent: "space-between",
        height: "56px",
        textAlign: "left",
      }}
    >
      <Typography fontSize="15px">{option.label}</Typography>
      {isMultipleChoice ? (
        <Checkbox checked={isSelected} color="primary" />
      ) : null}
    </Button>
  );
};

export default ChoiceOption;
